<template>
    <router-link to="/">
    <div class="conpany-header flex">
        <img src="@/assets/image/logo.png" />
    </div>
    </router-link>
</template>

<script>
    export default {
        name: "company"
    }
</script>

<style scoped>
    .conpany-header{
        height: 41px;
        text-align: left;
        margin-left: 50px;
        margin-top: 26px;
        margin-bottom: 20px;
    }
    .conpany-header i{
        line-height: 41px;
        font-size: 142px;
    }
    .conpany-header .boxs{
        margin-left: 15px;
    }
    .conpany-header .boxs .name{
        font-size: 20px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #0067AC;
    }
    .conpany-header .boxs .en{
        font-size: 13px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #0067AC;
    }
</style>
